export default "__VITE_ASSET__DQ2zsnTC__"